import React, { useState, useEffect } from "react";
import ChildHelps from "./ChildHelps";
import FAQs from "./FAQs";
import OverallRatings from "./OverallRatings";
import ParticipateFlow from "./ParticipateFlow";
import "./style.css";
import secgirl from "../../Assets/Images/competitions/sec-girl-icon.png";
import bluedott from "../../Assets/Images/competitions/bluedott.png";
import CompetetionCard from "./CompetetionCard";
import ExperientialProgramCard from "./ExperientialProgramCard";
import Carousel from "../../Components/Carousel";
import { SwiperSlide } from 'swiper/react';
import { ageRange, getAgeRange } from "../../helper";
import { useDispatch, useSelector } from "react-redux";
import { getGuestEvents, saveEventAge } from "../../redux/actions/event";

const Champions = () => {

  const dispatch = useDispatch();
  const compList = useSelector(state => state.event.compList);
  const expList = useSelector(state => state.event.expList);
  const quizList = useSelector(state => state.event.quizList);
  const compAge = useSelector(state => state.event.compAge);
  const expAge = useSelector(state => state.event.expAge);
  const quizAge = useSelector(state => state.event.quizAge);

  const [eventAge, setEventAge] = useState();

  useEffect(() => {
    if (compAge) {
      const [minAge, maxAge] = getAgeRange(compAge);
      const data = {
        min_age: parseInt(minAge),
        max_age: parseInt(maxAge),
        event_type: 0,
        is_closed: true
      };
      dispatch(getGuestEvents(data));
    }
  }, [compAge]);

  useEffect(() => {
    if (expAge) {
      const [minAge, maxAge] = getAgeRange(expAge);
      const data = {
        min_age: parseInt(minAge),
        max_age: parseInt(maxAge),
        event_type: 1,
        is_closed: true,
        is_quiz_only: false
      };
      dispatch(getGuestEvents(data));
    }
  }, [expAge]);

  useEffect(() => {
    if (quizAge) {
      const [minAge, maxAge] = getAgeRange(quizAge);
      const data = {
        min_age: parseInt(minAge),
        max_age: parseInt(maxAge),
        is_quiz_only: true
      };
      dispatch(getGuestEvents(data));
    }
  }, [quizAge]);

  const handleEventAge = (e, type) => {
    const { value } = e?.target;
    dispatch(saveEventAge(value, type));
  }
const options = {
    slidesPerView: 2.5,
    spaceBetween: 10,
    scrollbar: { hide: true },
    className: "mySwiper",
};
  const myBreakpoints = {
    320: {
    slidesPerView: 1,
    spaceBetween: 10,
    },
  640: {
    slidesPerView: 1,
    spaceBetween: 10,
  },
  768: {
    slidesPerView: 2,
    spaceBetween: 10,
  },
  1024: {
    slidesPerView: 2.5,
    spaceBetween: 10,
  },
};
  return (
    <div className="wrapper champion-landing-wrapper px-4">
      <div className="competitions-content">
        <div className="chmpn-container">
          <div className="chmpn-main-hdng text-center">
            <h3 id="competitions" className="main-hdng-title">Competitions</h3>
            <div className="chmpn-register-select-btn">
              <select className="form-select chmpn-custom-selecter" onChange={(e) => handleEventAge(e, 0)} value={compAge}>
                {ageRange && ageRange?.map((item, index) => <option value={item} key={index}> Age {item}</option>)}
              </select>
            </div>
          </div>
          <div className="chmpn-sec-text">
            <img className="sec-grl-img" src={secgirl} alt="icon" />
            <div className="chmpn-sec-text-con">
              <p>
                Organized by KidEx, AIM (NITI Aayog) & strategic partners.
                Activities to be completed before competition end date. Feature
                across leaderboards, win exciting prizes, digital trophies &
                certificates.
              </p>
              <span>
                Fixed timelines
                <img className="blue-dot-img-mb" src={bluedott} alt="bnnr" />
                Discounted registration fee for early birds
              </span>
            </div>
          </div>
          <div className="chmp-post-slider">
            <Carousel id="competetions" newOptions={ options} breakpoints={myBreakpoints}>
              {compList?.map((data, key) => <SwiperSlide key={key} ><CompetetionCard data={data} /></SwiperSlide>)}
            </Carousel>
          </div>
        </div>
      </div>
      <div className="competitions-content">
        <div className="chmpn-container">
          <div className="chmpn-main-hdng text-center">
            <h3 id="competitions" className="main-hdng-title">Experiential programs</h3>
            <div className="chmpn-register-select-btn">
              <select className="form-select chmpn-custom-selecter" onChange={(e) => handleEventAge(e, 1)} value={expAge}>
                {ageRange && ageRange?.map((item, index) => <option value={item} key={index}> Age {item}</option>)}
              </select>
            </div>
          </div>
          <div className="chmpn-sec-text">
            <img className="sec-grl-img" src={secgirl} alt="icon" />
            <div className="chmpn-sec-text-con">
              <p>
                Attempt expert curated activities anytime during academic year
                at own pace. Helps in all-rounded development & skills'
                enhancement. Win exciting digital trophies & certificates.
              </p>
              <span>
                Complete activities at your own pace
                <img className="blue-dot-img-mb" src={bluedott} alt="bnnr" />
                Register anytime!
              </span>
            </div>
          </div>
          <div className="chmp-post-slider">
            <Carousel id="experiential" breakpoints={myBreakpoints}>
              {expList?.map((data, key) => <SwiperSlide key={key}><ExperientialProgramCard data={data} /></SwiperSlide>)}
            </Carousel>
          </div>
        </div>
      </div>
      <div className="competitions-content">
        <div className="chmpn-container">
          <div className="chmpn-main-hdng text-center">
            <h3 id="competitions" className="main-hdng-title">Quizzes</h3>
            <div className="chmpn-register-select-btn">
              <select className="form-select chmpn-custom-selecter" onChange={(e) => handleEventAge(e, 2)} value={quizAge}>
                {ageRange && ageRange?.map((item, index) => <option value={item} key={index}> Age {item}</option>)}
              </select>
            </div>
          </div>
          <div className="chmpn-sec-text">
            <img className="sec-grl-img" src={secgirl} alt="icon" />
            <div className="chmpn-sec-text-con">
              <p>
                Explore a wide-range of topics of fun, short quizzes for best
                use of child's time. Quizzes help enhance memory, and
                observation in a game-based learning environment.
              </p>
              <span>
                Take quizzes anytime
                <img className="blue-dot-img-mb" src={bluedott} alt="bnnr" />
                Win trophies
              </span>
            </div>
          </div>
          <div className="chmp-post-slider">
            <Carousel id="quiz" breakpoints={myBreakpoints}>
              {quizList?.map((data, key) => <SwiperSlide key={key}><ExperientialProgramCard data={data} /></SwiperSlide>)}
            </Carousel>
          </div>
        </div>
      </div>
      <div className="competitions-content">
        <div className="chmpn-container">
          <div className="chmp-pricipate-flow context_narchome">
            <div className="chmpn-main-hdng text-center">
              <h3 className="main-hdng-title" id="chmp-participate">
                How to participate in Championships ?
              </h3>
            </div>
            <ParticipateFlow />
          </div>
        </div>
      </div>
      <div className="competitions-content">
        <div className="chmpn-container">
          <div className="narcLand my-5">
            <div className="chmpn-main-hdng text-center">
              <h3 className="main-hdng-title">
                How do KidEx Championships helps in holistic child development?
              </h3>
            </div>
            <ChildHelps />
          </div>
        </div>
      </div>
      <div className="competitions-content">
        <div className="chmpn-container">
          <div className="narcLand my-5">
            <div className="chmpn-main-hdng text-center">
              <h3 className="main-hdng-title">
                Rated by 70,000+ kids, parents and teachers across India
              </h3>
            </div>
            <OverallRatings />
          </div>
        </div>
      </div>
      <div className="competitions-content">
        <div className="chmpn-container">
          <div className="narcLand my-5">
            <div className="chmpn-main-hdng text-center">
              <h3 className="main-hdng-title">
                Frequently Asked Questions (FAQs)
              </h3>
            </div>
            <FAQs />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Champions;
